module.exports = __webpack_public_path__ + "static/img/5.ba6f158.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/5.png
// module id = 475
// module chunks = 1